import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../../../api";

const LatestNews = () => {
  const [events, setEvents] = useState([]);
  const [heading, setHeading] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await api.get("/api/sitepages/alumni/events");
        const eventsData = response.data.events_data;

        if (eventsData) {
          setEvents(eventsData.events || []);
          setHeading(eventsData.heading || "Latest News & Events");
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  if (loading || !events.length) return null;

  return (
    <section className="mb-5 news_events">
      <div className="container">
        <div className="alumni_side pt-5">
          <h3 >
            {heading}
          </h3>
        </div>

        <div
          className="row d-flex justify-content-center align-items-center "
         
        >
          <Slider {...settings} className="mt-5 w-100 alumni-latest-news" >
            {events.map((event, index) => (
              <div className="item px-0 px-md-3 " key={index}>
                <div className="event-card mb-5 text-center">
                  <div className="event-thumb">
                    <img className="w-100" src={`${process.env.REACT_APP_API_URL}/public/${event.image}`} alt={event.title} />
                  </div>
                  <div className="event-content">
                    <h5 className="event-title mb-2">{event.title}</h5>
                    <p className="event-body">{event.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default LatestNews;